import { Root } from '@radix-ui/react-select';
import { ComponentPropsWithoutRef } from 'react';
import { SelectContent } from './select-content';
import { SelectGroup } from './select-group';
import { SelectItem } from './select-item';
import { SelectLabel } from './select-label';
import { SelectScrollDownButton } from './select-scroll-down-button';
import { SelectScrollUpButton } from './select-scroll-up-button';
import { SelectSeparator } from './select-separator';
import { SelectTrigger } from './select-trigger';
import { SelectValue } from './select-value';

type Props = ComponentPropsWithoutRef<typeof Root>;
const SelectRoot = (props: Props) => {
    return <Root data-testid="select" {...props} />;
};

export const Select = Object.assign(SelectRoot, {
    Content: SelectContent,
    Group: SelectGroup,
    Item: SelectItem,
    Label: SelectLabel,
    ScrollDownButton: SelectScrollDownButton,
    ScrollUpButton: SelectScrollUpButton,
    Separator: SelectSeparator,
    Trigger: SelectTrigger,
    Value: SelectValue,
});
